import {NgModule} from '@angular/core';
import {BlockUIModule} from 'primeng/blockui';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {JbConfigPagePage} from './page/jb-config-page/jb-config-page.page';
import {
    JbJobRunObjectComponent
} from './component/protected-components/object-base/jb-job-run-object-component/jb-job-run-object.component';
import {
    JbJobRunSideComponent
} from './component/protected-components/object-base/jb-job-run-object-component/view/side/jb-job-run-side.component';
import {
    JbJobRunFullComponent
} from './component/protected-components/object-base/jb-job-run-object-component/view/full/jb-job-run-full.component';
import {
    JbJobRunBaseComponent
} from './component/protected-components/object-base/jb-job-run-object-component/view/jb-job-run-base.component';
import {JbJobStatusComponent} from './component/protected-components/jb-job-status/jb-job-status.component';
import {JobDashboardPage} from './page/job-dashboard-page/job-dashboard.page';
import {
    JbJobGroupBatchOverviewComponent
} from './component/protected-components/jb-job-group-batch-overview-component/jb-job-group-batch-overview.component';
import {
    JbSingleJobBatchOverviewComponent
} from './component/protected-components/jb-single-job-batch-overview-component/jb-single-job-batch-overview.component';
import {
    JbJobInstanceDetailsComponent
} from './component/protected-components/jb-job-instance-details-component/jb-job-instance-details.component';
import {
    JbJobBatchStatsComponent
} from './component/protected-components/jb-job-batch-stats/jb-job-batch-stats.component';
import {
    JbJobExecutionOverlapComponent
} from './component/protected-components/jb-job-execution-overlap-component/jb-job-execution-overlap.component';
import {
    JbSpringBatchIndicatorComponent
} from './component/protected-components/jb-spring-batch-indicator/jb-spring-batch-indicator.component';
import {
    JbJobTypeDashboardComponent
} from './component/protected-components/jb-job-type-dashboard-component/jb-job-type-dashboard.component';
import {
    JbJobRunDashboardComponent
} from './component/protected-components/jb-job-run-dashboard-component/jb-job-run-dashboard.component';
import {
    JbDashboardOverviewComponent
} from './component/protected-components/jb-dashboard-overview-component/jb-dashboard-overview.component';
import {
    JbThreadAnalysisComponent
} from './component/protected-components/jb-thread-analysis-component/jb-thread-analysis.component';
import {
    JbJobRunListComponent
} from './component/public-components/jb-job-run-list/jb-job-run-list.component';
import {JB_ENTITY_PROVIDER} from './jb.entity-provider';
import {CoreModule} from '../../core/core.module';
import {UiModule} from '../../core/ui/ui.module';
import {DynamicModule} from '../../core/shared/interface/dynamic-module.interface';
import {ModuleRegistryService} from '../../core/shared/interface/module-registration.service';
import {RouterOutlet} from '@angular/router';
import {JB_TEST_PROVIDERS} from './test/jb-test-definition';

@NgModule({
    declarations: [
        JbConfigPagePage,
        JbJobRunObjectComponent,
        JbJobRunSideComponent,
        JbJobRunFullComponent,
        JbJobRunBaseComponent,
        JbJobStatusComponent,
        JobDashboardPage,
        JbJobGroupBatchOverviewComponent,
        JbSingleJobBatchOverviewComponent,
        JbJobInstanceDetailsComponent,
        JbJobBatchStatsComponent,
        JbJobExecutionOverlapComponent,
        JbSpringBatchIndicatorComponent,
        JbJobTypeDashboardComponent,
        JbJobRunDashboardComponent,
        JbDashboardOverviewComponent,
        JbThreadAnalysisComponent,
        JbJobRunListComponent,
    ],
    exports: [
        JbConfigPagePage,
        JbJobRunObjectComponent,
        JbJobRunSideComponent,
        JbJobRunFullComponent,
        JbJobRunBaseComponent,
        JbJobStatusComponent,
        JobDashboardPage,
        JbJobGroupBatchOverviewComponent,
        JbSingleJobBatchOverviewComponent,
        JbJobInstanceDetailsComponent,
        JbJobExecutionOverlapComponent,
        JbSpringBatchIndicatorComponent,
        JbJobTypeDashboardComponent,
        JbJobRunDashboardComponent,
        JbDashboardOverviewComponent,
        JbThreadAnalysisComponent,
        JbJobRunListComponent,
    ],
    imports: [
        CoreModule,
        UiModule,
        BlockUIModule,
        ProgressSpinnerModule,
        ConfirmPopupModule,
        ConfirmDialogModule,
        RouterOutlet
    ],
    providers: [JB_ENTITY_PROVIDER, JB_TEST_PROVIDERS]
})
export class JbModule implements DynamicModule {

    alias = 'jb';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }
}
